module.exports = __webpack_public_path__ + "assets/icon-staging.0d1f3f5b.svg";